<template lang="pug">
  .grid-item
    .grid-block.bio-block {{ bioText | truncate(100)}}
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true },
  },

  data() {
    return {}
  },

  computed: {
    bioText,
  },

  watch: {},

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
function bioText() {
  return this.user.bio || 'No Bio set'
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
